module.exports = __webpack_public_path__ + "resources/icon_50_more_dark.e0942c0d68222445.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/group-or-game-header/img/icon_50_more_dark.png
// module id = 900
// module chunks = 0